// @ts-check
import { signal, effect } from '@preact/signals';
import { readStorage, writeStorage } from '../../lib/utils.js';

const EXPANDED_STORAGE_KEY = 'appcrm.isNavigationDrawerExpanded';

/** Gaveta expandida (220 px) ou trilho de ícones (40 px) no desktop. */
export const isNavigationDrawerExpandedState = signal(readStorage(EXPANDED_STORAGE_KEY, 'true') !== 'false');

/** Gaveta aberta como sobreposição no mobile (abaixo de 768 px). */
export const isMobileNavigationOpenState = signal(false);

effect(() => {
  writeStorage(EXPANDED_STORAGE_KEY, String(isNavigationDrawerExpandedState.value));
});

export function toggleNavigationDrawer() {
  isNavigationDrawerExpandedState.value = !isNavigationDrawerExpandedState.value;
}
